<template>
    <div class="viewport overflow-hidden">
        <div class="container">
            <h1 class="viewport-header">
                <div class="flex absolute watermark">CENNÍK</div>
                Koľko to stojí?
            </h1>

            <div class="serviceContainer full-width">
                <div
                    class="row items-stretch"
                    :class="{
                        'q-col-gutter-md': $q.screen.lt.sm,
                        'q-col-gutter-xl': $q.screen.gt.xs,
                    }"
                >
                    <Animation
                        animationName="animate__flipInY"
                        inView
                        class="flex justify-center col-12 col-sm-6 col-lg-3"
                        :customDelay="{ '0s': $q.screen.gt.xs }"
                    >
                        <div class="service">
                            <div class="header">
                                <div class="type">Chcem vyskúšať</div>
                                <div class="price">
                                    <span class="textBig">Zdarma</span>
                                    <span class="textSmall"></span>
                                </div>
                                <div class="discount">
                                    <div>Za vyskúšanie nič nedáte</div>
                                </div>
                            </div>
                            <div class="content">
                                <q-item>
                                    <q-item-section
                                        avatar
                                        top
                                    >
                                        <q-icon
                                            name="done"
                                            color="primary"
                                            size="md"
                                        />
                                    </q-item-section>
                                    <q-item-section side>
                                        <span class="text-dark text-h7">Nástenka vyhlásených zákazok</span>
                                    </q-item-section>
                                </q-item>
                                <q-item>
                                    <q-item-section
                                        avatar
                                        top
                                    >
                                        <q-icon
                                            name="done"
                                            color="primary"
                                            size="md"
                                        />
                                    </q-item-section>
                                    <q-item-section side>
                                        <span class="text-dark text-h7">Možnosť prihlásiť sa do zákazky</span>
                                    </q-item-section>
                                </q-item>
                            </div>
                        </div>
                    </Animation>
                    <Animation
                        animationName="animate__flipInY"
                        inView
                        class="flex justify-center col-12 col-sm-6 col-lg-3"
                        :customDelay="{ '0.1s': $q.screen.gt.xs }"
                    >
                        <div class="service">
                            <div class="header">
                                <div class="type">Obstarávame zriedka</div>
                                <div class="price">
                                    <span class="textBig">{{ priceList[0]?.value }}€ /</span>
                                    <span class="textSmall">1 mesiac</span>
                                </div>
                                <div class="discount">
                                    <div>Na začiatok to stačí</div>
                                </div>
                            </div>
                            <div class="content">
                                <q-item>
                                    <q-item-section
                                        avatar
                                        top
                                    >
                                        <q-icon
                                            name="done"
                                            color="primary"
                                            size="md"
                                        />
                                    </q-item-section>
                                    <q-item-section side>
                                        <span class="text-dark text-h7">Možnosť hľadať a filtrovať v zákazkách</span>
                                    </q-item-section>
                                </q-item>
                                <q-item>
                                    <q-item-section
                                        avatar
                                        top
                                    >
                                        <q-icon
                                            name="done"
                                            color="primary"
                                            size="md"
                                        />
                                    </q-item-section>
                                    <q-item-section side>
                                        <span class="text-dark text-h7">Možnosť vyhlásiť vlastné obstarávanie</span>
                                    </q-item-section>
                                </q-item>
                                <q-item>
                                    <q-item-section
                                        avatar
                                        top
                                    >
                                        <q-icon
                                            name="done"
                                            color="primary"
                                            size="md"
                                        />
                                    </q-item-section>
                                    <q-item-section side>
                                        <span class="text-dark text-h7">Možnosť mať viacero používateľov a správcov organizácie</span>
                                    </q-item-section>
                                </q-item>
                            </div>
                        </div>
                    </Animation>
                    <Animation
                        animationName="animate__flipInY"
                        inView
                        class="flex justify-center col-12 col-sm-6 col-lg-3"
                        :customDelay="{ '0.2s': $q.screen.gt.xs }"
                    >
                        <div class="service">
                            <div class="header">
                                <div class="type">Obstarávame často</div>
                                <div class="price">
                                    <span class="textBig">{{ priceList[1]?.value }}€ /</span>
                                    <span class="textSmall">6 mesiacov</span>
                                </div>
                                <div class="discount">
                                    <div>
                                        (Ušetríte <span class="text-bold">{{ priceList[0] ? priceList[0]?.value * 6 - priceList[1]?.value : '0' }}€</span>)
                                    </div>
                                </div>
                            </div>
                            <div class="content">
                                <q-item>
                                    <q-item-section
                                        avatar
                                        top
                                    >
                                        <q-icon
                                            name="done"
                                            color="primary"
                                            size="md"
                                        />
                                    </q-item-section>
                                    <q-item-section side>
                                        <span class="text-dark text-h7">Možnosť hľadať a filtrovať v zákazkách</span>
                                    </q-item-section>
                                </q-item>
                                <q-item>
                                    <q-item-section
                                        avatar
                                        top
                                    >
                                        <q-icon
                                            name="done"
                                            color="primary"
                                            size="md"
                                        />
                                    </q-item-section>
                                    <q-item-section side>
                                        <span class="text-dark text-h7">Možnosť vyhlásiť vlastné obstarávanie</span>
                                    </q-item-section>
                                </q-item>
                                <q-item>
                                    <q-item-section
                                        avatar
                                        top
                                    >
                                        <q-icon
                                            name="done"
                                            color="primary"
                                            size="md"
                                        />
                                    </q-item-section>
                                    <q-item-section side>
                                        <span class="text-dark text-h7">Možnosť mať viacero používateľov a správcov organizácie</span>
                                    </q-item-section>
                                </q-item>
                            </div>
                        </div>
                    </Animation>
                    <Animation
                        animationName="animate__flipInY"
                        inView
                        class="flex justify-center col-12 col-sm-6 col-lg-3"
                        :customDelay="{ '0.3s': $q.screen.gt.xs }"
                    >
                        <div class="service">
                            <div class="header">
                                <div class="type">Obstarávame neustále</div>
                                <div class="price">
                                    <span class="textBig">{{ priceList[2]?.value }}€ /</span>
                                    <span class="textSmall">12 mesiacov</span>
                                </div>
                                <div class="discount">
                                    <div>
                                        (Ušetríte <span class="text-bold">{{ priceList[0] ? priceList[0]?.value * 12 - priceList[2]?.value : '0' }}€</span>)
                                    </div>
                                </div>
                            </div>
                            <div class="content">
                                <q-item>
                                    <q-item-section
                                        avatar
                                        top
                                    >
                                        <q-icon
                                            name="done"
                                            color="primary"
                                            size="md"
                                        />
                                    </q-item-section>
                                    <q-item-section side>
                                        <span class="text-dark text-h7">Možnosť hľadať a filtrovať v zákazkách</span>
                                    </q-item-section>
                                </q-item>
                                <q-item>
                                    <q-item-section
                                        avatar
                                        top
                                    >
                                        <q-icon
                                            name="done"
                                            color="primary"
                                            size="md"
                                        />
                                    </q-item-section>
                                    <q-item-section side>
                                        <span class="text-dark text-h7">Možnosť vyhlásiť vlastné obstarávanie</span>
                                    </q-item-section>
                                </q-item>
                                <q-item>
                                    <q-item-section
                                        avatar
                                        top
                                    >
                                        <q-icon
                                            name="done"
                                            color="primary"
                                            size="md"
                                        />
                                    </q-item-section>
                                    <q-item-section side>
                                        <span class="text-dark text-h7">Možnosť mať viacero používateľov a správcov organizácie</span>
                                    </q-item-section>
                                </q-item>
                            </div>
                        </div>
                    </Animation>
                </div>
            </div>
            <div class="buttonPanel row q-gutter-sm justify-center">
                <CButtonVue
                    to="/cennik"
                    color="primary"
                    label="Zobraziť viac informácií"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Animation from '@/components/animation.vue';
import CButtonVue from '@/components/CButton.vue';

export default {
    name: 'VpCennik',
    props: {
        priceList: null,
    },
    components: {
        Animation,
        CButtonVue,
    },
};
</script>

<style lang="scss" scoped>
.container {
    max-width: $breakpoint-lg-max;
}
.serviceContainer {
    .service {
        width: 100%;
        max-width: 420px;
        overflow: hidden;
        @include box-shadow(0px 5px 15px 0px rgba($primary, 0.3));
        @include border-radius(15px);
        .header {
            height: 240px;
            padding: 24px;
            background: $primary;
            color: white;
            position: relative;
            background: url(@/assets/wave.svg);
            background-size: 420px auto;
            background-repeat: no-repeat;

            .type {
                margin-bottom: 8px;
            }
            .price {
                line-height: 1;
                margin-bottom: 8px;
                font-weight: bold;
                .textBig {
                    font-size: em(32);
                }
                .textSmall {
                    font-size: em(14);
                    margin-left: 8px;
                }
            }

            @media (max-width: $breakpoint-xs-max) {
                .type {
                    text-align: center;
                    font-size: em(20);
                }
                .price,
                .discount {
                    display: flex;
                    align-items: flex-end;
                    justify-content: center;

                    .textBig {
                        font-size: em(32);
                    }
                    .textSmall {
                        font-size: em(20);
                        margin-left: 8px;
                        margin-bottom: 1px;
                    }
                }
            }
        }

        .content {
            margin: 0px auto 70px auto;
            :deep() .q-item {
                min-height: 40px;
                padding: 0px 24px 8px 24px;
                font-size: 18px;

                > .q-item__section:last-child {
                    padding-right: 0;
                }
            }
        }
    }
}
</style>
